import { Grid, GridSize } from "@material-ui/core";
import CustomDatePickerInput from "./CustomDatePickerInput";
import React, { useEffect } from "react";
import { useFormState } from "react-final-form";
import moment from "moment";
import { get } from "lodash";

interface ICustomDateRangeInput {
  toSource: string;
  fromSource: string;
  toLabel?: string;
  fromLabel?: string;
  parentStartDate?: string;
  toMaxDate?: string;
  fromMaxDate?: string;
  excludeDates?: IExcludeDates[];
  isWeekdays?: boolean;
  isDisabled?: boolean;
  gridItemWidth?: GridSize;
}

export const isDateRangeInvalid = (
  startDate: string,
  endDate: string,
  excludedDates: IExcludeDates[],
) => {
  const selectedStart = new Date(startDate);
  const selectedEnd = new Date(endDate);

  if (selectedStart > selectedEnd) {
    return true;
  }

  // No need to check excludedDates if it's empty
  if (!excludedDates) {
    return false;
  }

  // No need to check excludedDates if it's empty
  if (excludedDates.length < 0) {
    return false;
  }

  for (const excluded of excludedDates) {
    const excludedStart = new Date(excluded.startDate);
    const excludedEnd = new Date(excluded.endDate);

    // Check if the selected range overlaps with the excluded range
    if (selectedStart <= excludedEnd && selectedEnd >= excludedStart) {
      return true;
    }
  }

  return false;
};

const CustomDateRangeInput = ({
  fromSource,
  toSource,
  fromLabel,
  toLabel,
  excludeDates,
  isWeekdays,
  parentStartDate,
  fromMaxDate,
  toMaxDate,
  isDisabled,
  gridItemWidth = "auto",
}: ICustomDateRangeInput) => {
  const [isError, setIsError] = React.useState(false);
  const { values } = useFormState();

  const startDate = get(values, fromSource);
  const endDate = get(values, toSource);

  useEffect(() => {
    if (startDate && endDate) {
      if (isDateRangeInvalid(startDate, endDate, excludeDates)) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    }
  }, [startDate, endDate]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={gridItemWidth}>
        <CustomDatePickerInput
          name={fromSource}
          label={fromLabel}
          min={
            parentStartDate < moment().format("yyyy-MM-DD")
              ? moment().format("yyyy-MM-DD")
              : parentStartDate
          }
          max={fromMaxDate}
          excludeDates={excludeDates}
          isWeekDays={isWeekdays}
          disableValue={isDisabled}
          isError={isError}
        />
      </Grid>
      <Grid item xs={gridItemWidth}>
        <CustomDatePickerInput
          name={toSource}
          label={toLabel}
          min={startDate}
          max={toMaxDate}
          excludeDates={excludeDates}
          isWeekDays={isWeekdays}
          disableValue={isDisabled}
          isError={isError}
        />
      </Grid>
      <Grid item xs={12}></Grid>
    </Grid>
  );
};

export default CustomDateRangeInput;
